import { useLayoutEffect, useRef } from 'react';

/** Keep the grid mounted so either direction can reverse without a height jump. */
export default function SidebarDisclosure({ id, open, hasContent = true, className, children }) {
  const ref = useRef(null);
  const visible = open && hasContent;

  useLayoutEffect(() => {
    const body = ref.current;
    if (visible || !body?.contains(document.activeElement)) return;
    // A route change can close a branch while focus is still on one of its leaves.
    // Walk outward if its own trigger is inside another closed disclosure.
    let panel = body;
    let trigger;
    while (panel) {
      trigger = [...document.querySelectorAll('button[aria-controls]')]
        .find(button => button.getAttribute('aria-controls') === panel.id);
      if (!trigger?.closest('[inert]')) break;
      panel = trigger.closest('.ci-sidebar-disclosure[inert]');
    }
    trigger?.focus({ preventScroll: true });
  }, [visible]);

  return <div ref={ref} id={id} className={className + ' ci-sidebar-disclosure'}
    data-open={visible ? 'true' : 'false'} aria-hidden={!visible} inert={visible ? undefined : ''}>
    <div className="ci-sidebar-disclosure-clip">{children}</div>
  </div>;
}
